module.exports = __webpack_public_path__ + "circleLogo-4b26e68e705f9c6dae656c79e7211c08.png";